import React from "react";
import { Box, Button, Input, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import { utils } from "@workspace/shared";
import { useStyles } from "./styles";
import { FORGOT_PASSWORD_PAGE } from "../../util/constants";

const { validateEmail } = utils;

type PropTypes = {
  email: {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
  };
  password: {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
  };
  errorMessage: string;
  onSubmit: (e: React.FormEvent) => void;
};

const LoginView = ({ email, password, errorMessage, onSubmit }: PropTypes) => {
  const classes = useStyles();

  const isDisabled = () => {
    return password.value && validateEmail(email.value);
  };

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.content}>
        <img src={logo} className={classes.logo} alt={"Logo"} />
        <form>
          <label htmlFor={"email"} className={classes.label}>
            <Typography variant={"subtitle2"}>Email</Typography>
          </label>
          <Input
            id={"email"}
            className={classes.inputField}
            placeholder={"Email"}
            type={"email"}
            disableUnderline={true}
            value={email.value}
            onChange={email.onChange}
          />
          <label htmlFor={"password"} className={classes.label}>
            <Typography variant={"subtitle2"}>Password</Typography>
          </label>
          <Input
            id={"password"}
            className={classes.inputField}
            placeholder={"Password"}
            disableUnderline={true}
            type={"password"}
            value={password.value}
            onChange={password.onChange}
          />
          <div style={{ textAlign: "center" }}>
            <Button
              type={"submit"}
              variant={"contained"}
              className={classes.button}
              onClick={onSubmit}
              disabled={!isDisabled()}
            >
              Login
            </Button>
          </div>
        </form>
        <Link
          to={FORGOT_PASSWORD_PAGE}
          style={{
            textDecoration: "none",
            color: "rgba(255,255,255,0.8)",
            marginTop: 16,
            display: "block",
            textAlign: "center",
          }}
        >
          <Typography variant={"body2"}>Forgot Password?</Typography>
        </Link>
        {errorMessage && (
          <Typography
            className={classes.errorMessage}
            color={"error"}
            variant={"body2"}
          >
            {errorMessage}
          </Typography>
        )}
      </Box>
      {/* Safe link to the own website */
      /* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        className={classes.privacyLink}
        href={"https://paperflow.com/privacy-policy/"}
        target={"_blank"}
      >
        Privacy Policy
      </a>
    </Box>
  );
};

export default LoginView;
